// External dependencies.
import PosterMixin from '@/mixins/posterMixin'

// The poster preview is used to display a small version of a poster and allow for adding it to the cart.
import HangingFrame from '@/components/hanging-frame/component'

// Ingela P. Arrhenius.
import Babyroo from '@/components/posters/babyroo/component'
import BornStrong from '@/components/posters/born-strong/component'
import FoxyStrollin from '@/components/posters/foxy-strollin/component'
import Mockingbird from '@/components/posters/mockingbird/component'
import OwlinForYou from '@/components/posters/owlin-for-you/component'
import Peekaboo from '@/components/posters/peekaboo/component'
import RetroBaby from '@/components/posters/retro-baby/component'
import ScandinavianForest from '@/components/posters/scandinavian-forest/component'
import ShortyAndStretch from '@/components/posters/shorty-and-stretch/component'
import WhatTheFoxSay from '@/components/posters/what-the-fox-say/component'

// Peytil.
import Adorable from '@/components/posters/adorable/component'
import Playful from '@/components/posters/playful/component'
import Delightful from '@/components/posters/delightful/component'
import Rosette from '@/components/posters/rosette/component'

// Katarzyna Stróżyńska Goraj.
import BlossomA from '@/components/posters/blossom-a/component'
import BlossomB from '@/components/posters/blossom-b/component'
import BlossomC from '@/components/posters/blossom-c/component'
import BlossomD from '@/components/posters/blossom-d/component'
import BlossomE from '@/components/posters/blossom-e/component'
import BlossomF from '@/components/posters/blossom-f/component'
import BlossomG from '@/components/posters/blossom-g/component'
import BlossomH from '@/components/posters/blossom-h/component'
import BlossomI from '@/components/posters/blossom-i/component'
import BlossomJ from '@/components/posters/blossom-j/component'
import BlossomK from '@/components/posters/blossom-k/component'
import BlossomL from '@/components/posters/blossom-l/component'
import BlossomM from '@/components/posters/blossom-m/component'
import BlossomN from '@/components/posters/blossom-n/component'
import BlossomO from '@/components/posters/blossom-o/component'
import BlossomP from '@/components/posters/blossom-p/component'
import BlossomQ from '@/components/posters/blossom-q/component'
import BlossomR from '@/components/posters/blossom-r/component'
import BlossomS from '@/components/posters/blossom-s/component'
import BlossomT from '@/components/posters/blossom-t/component'
import BlossomU from '@/components/posters/blossom-u/component'
import BlossomV from '@/components/posters/blossom-v/component'
import BlossomW from '@/components/posters/blossom-w/component'
import BlossomX from '@/components/posters/blossom-x/component'
import BlossomY from '@/components/posters/blossom-y/component'
import BlossomZ from '@/components/posters/blossom-z/component'
import BlossomAring from '@/components/posters/blossom-aring/component'
import BlossomAuml from '@/components/posters/blossom-auml/component'
import BlossomOuml from '@/components/posters/blossom-ouml/component'
import BlossomAelig from '@/components/posters/blossom-aelig/component'
import BlossomOslash from '@/components/posters/blossom-oslash/component'
import BlossomYuml from '@/components/posters/blossom-yuml/component'

// Single view
import Draupadia from '@/components/posters/draupadia/component'

export default {
  name: 'poster-preview',
  mixins: [ PosterMixin ],
  props: {
    poster: {
      type: String,
      default: 'babyroo'
    },
    showMeta: {
      type: Boolean,
      default: true
    },
    list: {
      type: String,
      required: true
    },
    position: {
      type: Number,
      required: true
    }
  },
  components: {
    HangingFrame,
    Babyroo,
    BornStrong,
    FoxyStrollin,
    Mockingbird,
    OwlinForYou,
    Peekaboo,
    RetroBaby,
    ScandinavianForest,
    ShortyAndStretch,
    WhatTheFoxSay,
    Adorable,
    Playful,
    Delightful,
    Rosette,
    BlossomA,
    BlossomB,
    BlossomC,
    BlossomD,
    BlossomE,
    BlossomF,
    BlossomG,
    BlossomH,
    BlossomI,
    BlossomJ,
    BlossomK,
    BlossomL,
    BlossomM,
    BlossomN,
    BlossomO,
    BlossomP,
    BlossomQ,
    BlossomR,
    BlossomS,
    BlossomT,
    BlossomU,
    BlossomV,
    BlossomW,
    BlossomX,
    BlossomY,
    BlossomZ,
    BlossomAring,
    BlossomAuml,
    BlossomOuml,
    BlossomAelig,
    BlossomOslash,
    BlossomYuml,
    Draupadia
  },

  data () {
    return {
      selectedColor: { name: '', color: '' },
      adding: false,
      windowWidth: 0
    }
  },

  mounted () {
    this.selectedColor = this.metaData.colors[0]
    this.windowWidth = window.innerWidth

    /* This is removed due to Google shopping requiring visible buttons
    if (this.windowWidth < 767) {
      let el = this.$el.querySelector('.poster-container')
      el.addEventListener('click', this.triggerHover)
    }
    */
  },
  /* This is removed due to Google shopping requiring visible buttons
  destroyed () {
    let el = this.$el.querySelector('.poster-container')
    This is removed due to Google shopping requiring visible buttons
    el.removeEventListener('click', this.triggerHover)
  },
  */

  computed: {
    // metaData will loop through available meta data and return the one that applies to this poster.
    metaData () {
      let all = this.$store.getters.postersMetaData
      let ret = {}
      let self = this
      Object.entries(all).forEach(function (item) {
        if (item[0] === self.poster) {
          ret = item[1]
        }
      })
      return ret
    },

    name () {
      return this.metaData.name
    },

    artist () {
      return this.metaData.artist
    },

    dimensions () {
      return this.metaData.dimensions
    },

    colors () {
      return this.metaData.colors
    },

    price () {
      let prices = this.metaData.prices
      if (prices[this.$store.getters.currency.currency]) {
        return prices[this.$store.getters.currency.currency]
      }
      return prices['SEK'] // @todo Default?
    }
  },

  methods: {
    /* This is removed due to Google shopping requiring visible buttons
    closeOverlay () {
      if (this.windowWidth < 767) {
        let el = this.$el.querySelector('.overlay')
        if (el.classList.contains('hover')) {
          el.classList.remove('hover')
        }
      }
    },

    triggerHover (evt) {
      let el = this.$el.querySelector('.overlay')
      if (el.classList.contains('hover')) {
        el.classList.remove('hover')
      } else {
        el.classList.add('hover')
      }
    },
    */

    customize () {
      this.$store.dispatch('trackPosterClick', {
        poster: this.metaData,
        color: this.selectedColor,
        list: this.list,
        position: this.position
      })
      this.$router.push({
        name: 'poster',
        params: {
          poster: this.poster,
          color: this.selectedColor,
          list: this.list,
          position: this.position
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/poster-preview/script.js